import React, { useState, Fragment, useEffect, useCallback, useRef } from 'react';
import { styled } from '@mui/material/styles';
import LibraryHeader from './LibraryHeader';
import AddFolderModal from './AddFolderModal';
import Folder from './Folder';
import LibraryBreadCrum from './LibraryBreadCrum';
import BoxModal from 'components/BoxModal';
import Preview from 'views/ContentLibrary/Preview';
import { Button, Grid } from '@mui/material';

import {
	getContentLibraryData,
	deleteContentLibraryData,
	getContentFolders,
	updateContentFolders,
	createContentFolders,
	createContentFiles,
	updateContentFiles,
} from 'services/contentLibrary.service';
import * as api from '../../util/apis';
import { ENV } from '../../constants/Constants';
import { FileDrop } from 'react-file-drop';
import ShowFile from './ShowFile';
import NavigationIcon from '@mui/icons-material/Navigation';
import { ToastsContainer, ToastsStore, ToastsContainerPosition } from 'react-toasts';
import { Client, FileResult } from '@horasys/bellplus/common/types';
import UploadingProgress from './UploadingProgress';
import theme from 'theme';
import { useAppDispatch, useAppSelector } from 'Stores/Hooks/hooks';
import { SET_PROGRESS } from 'Stores/Slices/progressSlice';
import { SEND_MESSAGE } from 'Stores/Slices/errorHandlingSlice';
import { resetPopup, showPopup } from 'Stores/Slices/popUpSlice';
import { RootState } from 'Stores/store';

const PREFIX = 'ContentLibrary';

const classes = {
    root: `${PREFIX}-root`,
    extendedIcon: `${PREFIX}-extendedIcon`,
    fabSelectAsset: `${PREFIX}-fabSelectAsset`
};

const Root = styled('div')((
    {
        theme: any
    }
) => ({
    [`& .${classes.root}`]: {
		'& > *': {
			margin: theme.spacing(1),
		},
	},

    [`& .${classes.extendedIcon}`]: {
		marginRight: theme.spacing(1),
	},

    [`& .${classes.fabSelectAsset}`]: {
		paddingRight: theme.spacing(2),
		//marginBottom: theme.spacing(2),
		margin: theme.spacing(1),
	}
}));

interface FileDataInterface {
	assetUrl: string;
	assetId: number;
	fileName: string;
	folderId: number;
	id: number;
	userId: string;
	isSelected?: boolean;
	type?: string;
	duration: number;
}
interface FileDataArrayInterface {
	[index: number]: FolderObject;
}
interface FolderObject {
	folderName: '';
	id: '';
	parentFolderId: null;
	userId: string;
	isSelected?: boolean;
}
interface FolderArrayInterface {
	[index: number]: FolderObject;
}

interface Props {
	isSelectable?: boolean;
	onSelectFiles?: (files: Array<FileDataInterface>) => void;
	role?: string;
	mediaAssetType: FilterAssetType;
	adClientId: number;
	adClient?: any;
}
type FilterAssetType = 'video' | 'image' | 'all';
const ContentLibrary = (props: Props) => {
	const [showAddNewFolder, setShowAddNewFolder] = useState<boolean>(false);
	const {
		isSelectable,
		onSelectFiles,
		role,
		mediaAssetType,
		adClientId,
		adClient,
	} = props;
	const [assetType, setAssetType] = useState<FilterAssetType>('video');
	useEffect(() => {
		setAssetType(mediaAssetType);
	}, [mediaAssetType]);

	useEffect(() => {
		setClientId(adClientId);
	}, [adClientId]);
	const userDtails = localStorage.getItem('userDetails');
	//const selectedClientId = Number(localStorage.getItem('selectedClientId'));

	const parsedUserDetails = userDtails
		? JSON.parse(userDtails)
		: { data: { clientId: 1, id: 1, username: 'root' } };

	const folderObj: FolderObject = {
		folderName: parsedUserDetails?.data?.username,
		id: '',
		parentFolderId: null,
		userId: parsedUserDetails.data.id,
	};
	const [folderArray, setFolderArray] = useState<Array<FolderObject>>([
		{ ...folderObj },
	]);
	const [fileArray, setFilerArray] = useState<Array<FileDataInterface>>([]);

	const [currentFolderData, setCurrentFolderData] = useState<FolderObject>(folderObj);

	const [breadCrum, setSingleBreadCrum] = useState([folderObj]);
	const [breadCrumData, setBreadCrumData] = useState<Array<FolderObject>>(breadCrum);

	const [isRenameFolder, setIsRenameFolder] = useState(true);
	const [addFolderHeading, setAddFolderHeading] = useState('Create Folder');
	const [addFolderInputLabel, setAddFolderInputLabel] = useState('Folder Name');
	const [selectedFolderCount, setSelectedFolderCount] = useState(0);
	const [selectedFileCount, setSelectedFileCount] = useState(0);
	const [clientId, setClientId] = useState(adClientId);
	const [showConfirmModal, setShowConfirmModal] = useState(false);
	const [showPreview, setShowPreview] = useState(false);
	const [previewFileData, setPreviewFileData] = useState<FileDataInterface>();
	const progressArrayRef = useRef<any>([]);
  const dispatch = useAppDispatch();


	const addNewFolder = () => {
		setShowAddNewFolder(true);
		setIsRenameFolder(false);
		setAddFolderHeading('Create Folder');
		setAddFolderInputLabel('Folder Name');
	};

	const popup = useAppSelector((state: RootState) => state.popup);
	const { confirmation } = popup;

	const closeAddFolder = () => setShowAddNewFolder(false);

	const handleSelectFile = () => onSelectFiles && onSelectFiles(fileArray);
	const deleteSelectedFolder = useCallback(async () => {
		const fileIds = fileArray.filter((fd) => fd.isSelected).map((fd) => fd.id);
		const folderIds = folderArray.filter((fd) => fd.isSelected).map((fd) => fd.id);

		const data = {
			fileIds: fileIds,
			folderIds: folderIds,
		};
		try {
      dispatch(SET_PROGRESS(true));
			await deleteContentLibraryData(clientId, data);
      dispatch(SET_PROGRESS(false));
			setFilerArray((fileArray) => fileArray.filter((fd) => !fd.isSelected));
			setFolderArray((folderArray) => folderArray.filter((fd) => !fd.isSelected));
      dispatch(SEND_MESSAGE({ message: 'DELETED SUCCESSFULLY', type:'success'}));
		} catch (error:any) {
      dispatch(SEND_MESSAGE({ message: error, type:'error'}));
      dispatch(SET_PROGRESS(false));
		}
	}, [clientId, dispatch, fileArray, folderArray]);
	useEffect(() => {
		if (confirmation === 'agree') {
			dispatch(resetPopup());
			deleteSelectedFolder();
		}
	}, [confirmation, deleteSelectedFolder, dispatch]);

	const renameFolderReq = async (folderName: any) => {
		const selectedFolder = folderArray.filter((fd) => fd.isSelected);
		const renameFolderData = {
			folderName,
			userId: parsedUserDetails.data.id,
			parentFolderId: selectedFolder[0].parentFolderId,
		};
		const renameFolderResp: any = await updateContentFolders(
			clientId,
			selectedFolder[0].id,
			renameFolderData,
		);
		if (renameFolderResp) {
			setFolderArray((folders) => {
				return folders.map((fd) => {
					if (fd.id === renameFolderResp.id) {
						return renameFolderResp;
					} else {
						return fd;
					}
				});
			});
			setShowAddNewFolder(false);
		}
	};

	const renameFileReq = async (fileName: any) => {
		const selectedFile = fileArray.filter((fd) => fd.isSelected);
		const renameFileData = {
			fileName,
			userId: parsedUserDetails.data.id,
			folderId: selectedFile[0].folderId,
			assetId: selectedFile[0].assetId,
			type: selectedFile[0].type,
		};
		const renameFileResp: any = await updateContentFiles(
			clientId,
			selectedFile[0].id,
			renameFileData,
		);
		if (renameFileResp) {
			setFilerArray((files) => {
				return files.map((fd) => {
					if (fd.id === renameFileResp.id) {
						return renameFileResp;
					} else {
						return fd;
					}
				});
			});
			setShowAddNewFolder(false);
		}
	};

	const createFolderReq = async (name: any) => {
		const newFolder = {
			userId: parsedUserDetails.data.id,
			folderName: name,
			parentFolderId: currentFolderData?.id === '' ? null : currentFolderData?.id,
		};
		const addedfolderData: any = await createContentFolders(clientId, newFolder);
		if (addedfolderData) {
			setFolderArray((folders) => {
				const updatedFolderArray = [...folders, addedfolderData];
				return updatedFolderArray;
			});
			setShowAddNewFolder(false);
		}
	};

	const createFolder = async (name: string) => {
		if (isRenameFolder) {
			if (selectedFolderCount === 1) {
				renameFolderReq(name);
			} else {
				renameFileReq(name);
			}
		} else {
			createFolderReq(name);
		}
	};

	const selectFolder = (sFd: FolderObject) => {
		setFolderArray((folderArray) =>
			folderArray?.map((fd) => {
				if (fd.id === sFd.id) {
					fd.isSelected = !fd.isSelected;
					return fd;
				}
				return fd;
			}),
		);
	};

	const getFolders = async (folderId: any) => {
		const contentData: any = await getContentFolders(clientId, folderId);
		if (contentData) {
			setFolderArray(contentData.folders);
			setFilerArray(contentData.files);
		}
	};

	const openFolder = (sFd: FolderObject) => {
		getFolders(sFd.id);
		setCurrentFolderData(sFd);
		setBreadCrumData((breadData) => [...breadData, sFd]);
	};

	const handleBreadCrumClick = (obj: FolderObject) => {
		if (obj.id === '') {
			fetchContentLibraryData();
			setCurrentFolderData(folderObj);
			setBreadCrumData(breadCrum);
		} else if (obj.id !== currentFolderData.id) {
			setCurrentFolderData(obj);
			let float = -1;
			breadCrumData?.map((bread, i) => {
				if (bread.id === obj.id) {
					float = i;
				}
			});
			const leftPeices: any = breadCrumData.slice(0, float + 1);
			getFolders(obj.id);
			setBreadCrumData(leftPeices);
		}
	};

	const fetchContentLibraryData = useCallback(async () => {
		const contentData: any = await getContentLibraryData(clientId);

		if (contentData) {
			setFolderArray(contentData?.folders);
			setFilerArray(contentData?.files);
		} else {
			alert('Some Error Occurs');
		}
	}, [clientId]);

	useEffect(() => {
		role === 'client' && fetchContentLibraryData();
	}, [fetchContentLibraryData, role]);

	const renderFolders = () => {
		return folderArray?.map((fd, i) => (
			<Folder
				key={fd.id}
				folderData={fd}
				selectFolder={selectFolder}
				openFolder={openFolder}
			/>
		));
	};

	const selectFile = (selectedFile: FileDataInterface) => {
		setFilerArray((fileList) =>
			fileList?.map((fd) => {
				if (fd.id === selectedFile.id) {
					fd.isSelected = !fd.isSelected;
					return fd;
				}
				return fd;
			}),
		);
	};

	const renderFiles = () => {
		return fileArray?.map((file: any, i: number) => (
			<ShowFile
				file={file}
				previewFile={previewFile}
				selectFile={selectFile}
				key={i}
				showAssetsType={assetType}
			/>
		));
	};

	const [progressbarVisibility, setProgressbarVisibility] = useState(false);
	const [uploadProgress, setUploadProgress] = useState(0);

	const typeOfFile = (file: any) => {
		return file && file['type'].split('/')[0];
	};

	const [result, setResult] = useState<FileResult>({
		fileName: '',
		duration: 0,
		id: 0,
		url: '',
		uploadStatus: '',
		mediaType: '',
	});

	const validateAsset = async (file: any): Promise<any> => {
		return new Promise((resolve, reject) => {
			const fileType = typeOfFile(file);

			if (fileType === 'image') {
				const resultObj = { ...result };
				resultObj.duration = 0;
				resultObj.mediaType = fileType;
				resultObj.fileName = file?.name;
				setResult(resultObj);
				resolve(resultObj);
			}

			const video = document.createElement('video');
			video.preload = 'metadata';
			video.src = window.URL.createObjectURL(file);

			video.onloadedmetadata = function () {
				window.URL.revokeObjectURL(video.src);
				let errorMessage: any;
				if (video.duration < 1) {
					errorMessage = 'Invalid Video! video is less than 1 second';
					reject(errorMessage);
				} else {
					const resultObj = { ...result };
					resultObj.duration = video.duration;
					resultObj.mediaType = 'video';
					setResult(resultObj);
					resolve(resultObj);
				}
			};
		});
	};

	const uploadAsset = async (
		file: any,
		resultObj: FileResult,
		index: number,
	): Promise<any> => {
		return new Promise(async (resolve, reject) => {
			//setProgressbarVisibility(true);
			if (
				file !== undefined &&
				file !== null &&
				file.size !== undefined &&
				file.size !== null &&
				file.size
			) {
				const formData = new FormData();
				formData.append('file', file);
				let progressCompleted;
				const config = {
					onUploadProgress: function (progressEvent: any) {
						progressCompleted = Math.round(
							(progressEvent.loaded * 100) / progressEvent.total,
						);
						const updatedProgress: any = [...progressArrayRef.current];
						updatedProgress[index] = progressCompleted;

						progressArrayRef.current = [...updatedProgress];
						const totalProgress = updatedProgress.reduce(
							(a: any, b: any) => a + b,
							0,
						);

						if (totalProgress > 99 * progressArrayRef.current.length) {
							setProgressbarVisibility(false);
						}
					},
				};

				const uploadAssetResp: any = await api.uploadapiresponses(
					ENV.dev.uploadassets + '?type=advertisement',
					formData,
					config,
				);
				resolve(uploadAssetResp);
			} else {
				reject('UploadAPIresponses rejected');
			}
		});
	};

	const uploadToContentLibrary = async (
		uploadAssetResp: any,
		file: any,
		resultObj: FileResult,
	): Promise<any> => {
		return new Promise(async (resolve, reject) => {
			if (
				uploadAssetResp !== undefined &&
				uploadAssetResp.data &&
				uploadAssetResp.data.errors !== undefined &&
				uploadAssetResp.data.errors.length === 0
			) {
				setResult(resultObj);

				const fileData = {
					userId: parsedUserDetails?.data?.id?.toString(),
					folderId: currentFolderData.id === '' ? null : currentFolderData.id,
					assetId: uploadAssetResp?.data?.data?.id,
					fileName: file?.name,
					type: file?.type?.includes('image') ? 'image' : 'video',
					duration: Math.floor(resultObj.duration),
				};

				if (uploadAssetResp) {
					const respFileData: any = await createContentFiles(
						clientId,
						fileData,
					);
					if (respFileData) {
						const addedFile: any = respFileData;
						setFilerArray((file: any) => {
							const updatedFileArray: any = [...file, addedFile];
							return updatedFileArray;
						});
					}
					return respFileData;
				} else {
					reject('Promise is rejected');
				}
			} else {
				reject('Promise is rejected');
			}
		});
	};

	const handleUploadFile = async (e: any) => {
		const filesInArray = [...e?.target?.files];
		const updatedValue: any = [];
		filesInArray.forEach(() => updatedValue.push(0));
		progressArrayRef.current = [...updatedValue];
		filesInArray.map(async (ele: any, index: number) => {
			setProgressbarVisibility(true);
			const file = e?.target?.files[index];
			const resultObj = await validateAsset(file);
			const uploadAssetResult = await uploadAsset(file, resultObj, index);
			await uploadToContentLibrary(uploadAssetResult, file, resultObj);
		});
	};

	const confirmDeleteModal = () => {
		//setShowConfirmModal((show) => !show)
		dispatch(showPopup('Are you sure that you want to delete?'));
	};

	const previewFile = (file: FileDataInterface) => {
		setPreviewFileData(file);
		togglePreview();
	};

	const togglePreview = () => {
		setShowPreview((show) => !show);
	};

	const renameFolder = () => {
		setShowAddNewFolder((show) => !show);

		setIsRenameFolder(true);
		if (selectedFileCount === 1) {
			setAddFolderHeading('Rename File');
			setAddFolderInputLabel('File Name');
		} else {
			setAddFolderHeading('Rename Folder');
			setAddFolderInputLabel('Folder Name');
		}
	};

	useEffect(() => {
		const selectedFolderCount = folderArray.reduce((show: any, fd: FolderObject) => {
			return fd?.isSelected ? show + 1 : show;
		}, 0);
		const selectedFileCount = fileArray.reduce((show: any, fd: FileDataInterface) => {
			return fd?.isSelected ? show + 1 : show;
		}, 0);
		setSelectedFolderCount(selectedFolderCount);
		setSelectedFileCount(selectedFileCount);
	}, [folderArray, fileArray]);

	const uploadThroughDropzone = (files: any, event: any) => {
		const e = {
			target: {
				files: files,
			},
		};
		handleUploadFile(e);
	};

	const [dragEnter, setDragEnter] = useState(false);

	const onFrameDragEnter = () => setDragEnter(true);

	const onFrameDragLeave = () => setDragEnter(false);

	useEffect(() => {
		clientId && fetchContentLibraryData();
	}, [clientId, fetchContentLibraryData]);

	const setClientName = (currentClient: number, clientData: Client) => {
		// setClientId(currentClient);
		const fdObj: any = {
			folderName: clientData.companyName,
			id: '',
			parentFolderId: null,
			userId: parsedUserDetails.data.id,
		};
		setSingleBreadCrum([fdObj]);
		setBreadCrumData([fdObj]);
	};

	return (
        <Root>
            <Fragment>
                <ToastsContainer
                    className="toast"
                    store={ToastsStore}
                    position={ToastsContainerPosition.TOP_CENTER}
                />
                {isSelectable && (
                    <Grid container justifyContent="flex-end" className={classes.fabSelectAsset}>
                        {/* <Fab variant="extended" onClick={handleSelectFile}>
                            <NavigationIcon className={classes.extendedIcon} />
                            Submit
                        </Fab> */}
                        <Button
                            startIcon={<NavigationIcon />}
                            style={{ backgroundColor:'#042630'}}
                            variant="contained"
                            onClick={handleSelectFile}>
                            Submit
                        </Button>
                    </Grid>
                )}
                <div className="content-library-wrapper">
                    {!isSelectable && (
                        <LibraryHeader
                            addNewFolder={addNewFolder}
                            deleteFolder={confirmDeleteModal}
                            handleUploadFile={handleUploadFile}
                            showRename={selectedFolderCount + selectedFileCount === 1}
                            showDelete={selectedFolderCount + selectedFileCount > 0}
                            renameFolder={renameFolder}
                            setClientName={setClientName}
                            role={role}
                        />
                    )}
                    {clientId > 0 && (
                        <div className="folder-container">
                            <LibraryBreadCrum
                                breadCrumArray={breadCrumData}
                                handleBreadCrumClick={handleBreadCrumClick}
                            />
                            <div className="folder-list">{renderFolders()}</div>
                            <FileDrop
                                onFrameDragEnter={onFrameDragEnter}
                                onFrameDrop={onFrameDragLeave}
                                onDrop={uploadThroughDropzone}
                                className={
                                    dragEnter
                                        ? 'drag-frame-outline enter-drag'
                                        : 'drag-frame-outline'
                                }>
                                <div className="files-container">{renderFiles()}</div>
                            </FileDrop>
                        </div>
                    )}
                </div>
                {showAddNewFolder && (
                    <AddFolderModal
                        isShow={showAddNewFolder}
                        handleClose={closeAddFolder}
                        createFolder={createFolder}
                        isRenameFolder={isRenameFolder}
                        heading={addFolderHeading}
                        inputLabel={addFolderInputLabel}
                        selectedFolderCount={selectedFolderCount}
                        selectedFileCount={selectedFileCount}
                    />
                )}
                <BoxModal
                    show={showConfirmModal}
                    handleClose={confirmDeleteModal}
                    head="Confirm Delete"
                    description="Deleting folder will delete the all content"
                    primaryEventContent="Delete"
                    primaryEventClick={deleteSelectedFolder}
                    secondaryEventContent="Cancel"
                    secondaryEventClick={confirmDeleteModal}
                />
                <Preview
                    fileName={previewFileData?.fileName}
                    srcpath={previewFileData?.assetUrl}
                    type={previewFileData?.type}
                    show={showPreview}
                    handleClose={togglePreview}
                />
            </Fragment>
            {progressbarVisibility && (
                <UploadingProgress progressArray={progressArrayRef?.current} />
            )}
            {/* {progressbarVisibility && (
                <UploadLoader
                    show={progressbarVisibility}
                    handleClose={toggleUploadPopup}
                    fileName={result.fileName}
                    progress={uploadProgress}
                />
            )} */}
        </Root>
    );
};

export default ContentLibrary;
